import React, { FC } from 'react';

import {
	EvFilters,
	EvSection,
	IFilterValues,
	TABLE_FILTERS_SR_SUMMARY
} from '@evinced-private/ui-common';

import { MFA_SESSION_FILTERS_SECTION_ID } from 'data-automation-ids/MfaDashboardAutomationIds';
import omit from 'lodash-es/omit';
import { useMfaSessionFilterOptionsQuery } from 'src/apps/mfa/hooks/useMfaSessionFilterOptionsQuery';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { flattenObject } from 'src/common/helpers/ObjectsHelper';

import { mfaSingleSessionFilterDefinitions } from './MfaSingleSessionFilterDefinitions';

import './MfaSingleSessionFiltersSection.scss';

interface IMfaSingleSessionFiltersProps {
	sessionId: string;
	filters: IFilterOptions;
	onFilterChange: (tableId: string, filters: IFilterOptions) => void;
	tableId: string;
	ariaLabel: string;
}

export const MfaSingleSessionFiltersSection: FC<IMfaSingleSessionFiltersProps> = ({
	sessionId,
	filters,
	onFilterChange,
	tableId,
	ariaLabel
}) => {
	const filterOptionsQuery = useMfaSessionFilterOptionsQuery(sessionId);

	const initialValues = {
		text: { searchValue: filters?.searchValue },
		select: omit(filters, 'searchValue')
	};

	const handleApply = (appliedFilters: IFilterValues): void => {
		const flatFilters = flattenObject<IFilterOptions>(appliedFilters);
		onFilterChange(tableId, flatFilters);
	};

	return (
		<EvSection
			ariaLabel={ariaLabel}
			ariaDescribedby={TABLE_FILTERS_SR_SUMMARY}
			ariaLive="polite"
			skipLinkId="filters-section"
			dataAutomationId={MFA_SESSION_FILTERS_SECTION_ID}
			className="mfa-single-session-filters-section"
		>
			<EvFilters
				className="data-filters"
				onApply={handleApply}
				onReset={handleApply}
				initialValues={initialValues}
				filterOptions={filterOptionsQuery.data ?? {}}
				isFilterOptionsLoaded={!filterOptionsQuery.isLoading}
				filterDefinitions={mfaSingleSessionFilterDefinitions}
			/>
		</EvSection>
	);
};
